module.exports = __webpack_public_path__ + "static/img/ys_btn1.205c194.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/home/pc/role3/control/ys_btn1.png
// module id = tsH6
// module chunks = 7